var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    rx: 33,
    fill: "#FFF0F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.758 24.6C34.2433 24.6 35.4475 23.3464 35.4475 21.8C35.4475 20.2536 34.2433 19 32.758 19C31.2726 19 30.0685 20.2536 30.0685 21.8C30.0685 23.3464 31.2726 24.6 32.758 24.6Z",
    fill: "#F94E6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.989 27.554C37.4645 27.008 36.5636 26 34.8154 26C34.533 26 32.9059 26 31.3998 26C27.7017 25.986 24.6895 22.85 24.6895 19H22C22 23.424 24.8374 27.176 28.7237 28.394V47H31.4132V38.6H34.1027V47H36.7922V30.27L42.1039 35.8L44 33.826L37.989 27.554Z",
    fill: "#F94E6C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.2b3426d3edd7fdf2dff5c48683d09d51.svg";
export { ForwardRef as ReactComponent };